export enum SelectedTrainDelay {
  NONE = 'NONE',
  ON_COURSE = 'ON_COURSE',
  ON_DAY = 'ON_DAY',
}
